var map = {
	"./asset_ui/src/store/context.js": 53918,
	"./communication_ui/src/store/context.js": 49014,
	"./file_ui/src/store/context.js": 33462,
	"./invoice_ui/src/store/context.js": 29627,
	"./ks_app/src/store/context.js": 71279,
	"./lms_ui/src/store/context.js": 41030,
	"./market_ui/src/store/context.js": 20488,
	"./marketing_ui/src/store/context.js": 98242,
	"./payment_ui/src/store/context.js": 73896,
	"./rms_ui/src/store/context.js": 87008,
	"./task_ui/src/store/context.js": 29119
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70782;